/**
 * Detect the user's regional preference for Qur'anic script.
 *
 * Returns 'indopak' for Pakistan / India / Bangladesh / Afghanistan, where
 * the Saleem/Noorehira "Indo-Pak" orthography is the dominant household
 * tradition; 'uthmani' for everyone else (Malaysia/MY, MENA, Indonesia,
 * default). Reads from navigator.language + navigator.languages.
 */
const INDOPAK_REGIONS = new Set(["PK", "IN", "BD", "AF"]);
const INDOPAK_LANG_PREFIXES = ["ur", "pa", "sd"]; // Urdu, Punjabi, Sindhi

export function detectDefaultScript() {
  if (typeof navigator === "undefined") return "uthmani";
  const candidates = []
    .concat(navigator.languages || [])
    .concat([navigator.language || ""])
    .filter(Boolean);
  for (const tag of candidates) {
    const norm = String(tag).replace("_", "-");
    const parts = norm.split("-");
    const lang = (parts[0] || "").toLowerCase();
    const region = (parts[parts.length - 1] || "").toUpperCase();
    if (INDOPAK_REGIONS.has(region)) return "indopak";
    if (INDOPAK_LANG_PREFIXES.includes(lang)) return "indopak";
  }
  return "uthmani";
}

export const SCRIPT_LABELS = {
  uthmani: "Uthmani (Madinah Mushaf)",
  indopak: "Indo-Pak (Saleem / Noorehira)",
};

export const SCRIPT_REGIONS = {
  uthmani: "Malaysia, Indonesia, Arab world, default",
  indopak: "Pakistan, India, Bangladesh, Afghanistan",
};
